import { render, staticRenderFns } from "./BelposhtaShow.vue?vue&type=template&id=8dab5fca&scoped=true"
import script from "./BelposhtaShow.vue?vue&type=script&lang=js"
export * from "./BelposhtaShow.vue?vue&type=script&lang=js"
import style0 from "./BelposhtaShow.vue?vue&type=style&index=0&id=8dab5fca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dab5fca",
  null
  
)

export default component.exports